import { render, staticRenderFns } from "./nav-footer.vue?vue&type=template&id=51a59652&scoped=true"
import script from "./nav-footer.vue?vue&type=script&lang=js"
export * from "./nav-footer.vue?vue&type=script&lang=js"
import style0 from "./nav-footer.vue?vue&type=style&index=0&id=51a59652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a59652",
  null
  
)

export default component.exports